module.exports = __webpack_public_path__ + "media/country_flags/mx-af339ae2.png";